// extracted by mini-css-extract-plugin
export default {"_":"main____tg3Bm","background2":"main_background2__ln6D9","fon":"main_fon__uhi4K"};